import type { ZbiToggleButton } from "@zebrabi/ui-components";
import BaseSwitcher from "@zebrabi/global-toolbar/dist/lib/components/global-toolbar/BaseSwitcher";
import GlobalToolbar from "@zebrabi/global-toolbar/dist/lib/components/GlobalToolbar";
import { toolbarGroupHeader } from "../templates/toolbarGroupHeader";
import { CLICK } from "../../library/constants";
import { Visual } from "../../visual";

abstract class BaseSwitcherWithHeader extends BaseSwitcher {
    protected getVisual() {
        return Visual;
    }

    /**
     * @override to add a header for all action containers
     * @param switcherMenuContainer
     * @param active
     */
    createMenuItems(switcherMenuContainer: HTMLElement, active: string = ""): void {
        this.createMenuHeader(switcherMenuContainer);
        super.createMenuItems(this.createMenuBody(switcherMenuContainer), active);
    }

    /**
     * generate the header with the title and bind events
     * @param switcherMenuContainer
     */
    createMenuHeader(switcherMenuContainer: HTMLElement) {
        const range = document.createRange();
        const groupHeaderFragment = range.createContextualFragment(toolbarGroupHeader);
        const title = groupHeaderFragment.querySelector(".title");
        const closeButton = groupHeaderFragment.querySelector(".close");

        title.textContent = this.toolbarOptions.elementName;
        closeButton.addEventListener(CLICK, (e) => {
            this.notifyAction(GlobalToolbar.SIDEBAR_CLOSE, ""); // let's notify action close toolbar
            e.preventDefault();
        });

        switcherMenuContainer.append(groupHeaderFragment);
    }

    protected createMenuBody(switcherMenuContainer: HTMLElement): HTMLElement {
        const body = document.createElement("div");
        body.classList.add("body");
        return switcherMenuContainer.appendChild(body);
    }

    public setScrollPosition(scrollPosition: number) {
        this.switcherScrollPosition = scrollPosition;
        const body = this.switcherContainer.querySelector(".body");

        if (body) {
            this.switcherContainer.querySelector(".body").scrollTop = this.switcherScrollPosition;
        }
    }

    public getScrollPosition(): number {
        const body = this.switcherContainer.querySelector(".body");

        if (body) {
            return this.switcherContainer?.querySelector(".body").scrollTop;
        }

        return 0;
    }

    /**
     * @override the base implementation only finds plain inputs, so zbi-* components
     * (whose input sits in the shadow DOM and fires its own event) have to be wired separately
     * @param formRoot
     */
    observeFormChanges(formRoot: HTMLElement): void {
        super.observeFormChanges(formRoot);

        for (const toggle of Array.from(formRoot.querySelectorAll<ZbiToggleButton>("zbi-toggle-button"))) {
            toggle.addEventListener("zbi-change", (event: Event) => {
                if (!toggle.name) {
                    return;
                }

                const returnData = new Map<string, any>();
                returnData.set(toggle.name, (<CustomEvent>event).detail?.value ?? toggle.value);

                this.switcherScrollPosition = this.getScrollPosition();
                this.notify(returnData, `${this.getClassName()}Observer`);
            });
        }
    }
}

export default BaseSwitcherWithHeader;
